import React, { useState } from 'react'
import { EllipsisHorizontalIcon } from '@heroicons/react/24/outline'

export default function FloatingMenuEllipsisButton({ settings }) {
    const [menuVisible, setMenuVisible] = useState(false)
    const [position, setPosition] = useState({ x: 0, y: 0 })

    const handleClick = () => {
        setMenuVisible(!menuVisible)
        const menuOffset = { x: -280, y: 0 }
        setPosition(menuOffset)
    }

    const getStyle = (color) => {
        switch (color) {
            case 'red':
                return 'flex items-center py-2 px-4 gap-x-4 cursor-pointer hover:bg-red-100 text-red-400'
            case 'gray':
                return 'flex items-center py-2 px-4 gap-x-4 cursor-pointer hover:bg-gray-100'
            default:
                return 'flex items-center py-2 px-4 gap-x-4 cursor-pointer hover:bg-gray-100'
        }
    }

    return (
        <>
            {/* Ellipsis Button */}
            <div className="flex items-center cursor-pointer h-8 text-gray-500 px-2 rounded-tr-lg hover:bg-stone-100" onClick={() => handleClick()}>
                <EllipsisHorizontalIcon className="h-6 pointer-events-none" />
            </div>

            {/* Settings menu popup */}
            <div className="relative">
                {menuVisible && (
                    <div className="absolute z-10 w-64 bg-white border border-gray-400 shadow-xl rounded p-2" style={{ left: position.x, top: position.y }}>
                        {settings.map((setting, index) => (
                            <div
                                key={index}
                                className={getStyle(setting.color)}
                                onClick={() => {
                                    setting.action()
                                    setMenuVisible(false)
                                }}
                            >
                                <setting.icon className="h-4" />

                                <div>{setting.text}</div>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </>
    )
}
